import { React } from "react";
import { DataGrid } from "@mui/x-data-grid";

export default function RDataGrid(props) {
  const { columns, rows, rowHeight, columnVisibilityModel } = props;

  const autosizeOptions = {
    includeOutliers: true,
    includeHeaders: true,
    outliersFactor: 1,
    expand: true,
  };

  //apiRef.current.autosizeColumns(autosizeOptions);

  const datagridSx = {
    borderRadius: 2,
    /* "& .MuiDataGrid-virtualScrollerRenderZone": {
      "& .MuiDataGrid-row": {
        "&:nth-child(2n)": {
          backgroundColor: "rgba(165, 215, 232, .07)",
          padding: 0,
        },
      },
    }, */
    /* "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "rgba(67, 176, 42, .1)",
      color: "rgba(0, 43, 91)",
      fontSize: 18,
      fontWeight: "bold",
    }, */
    "& .super-app-theme--header": {
      backgroundColor: "rgba(67, 176, 42, .1)",
      color: "rgba(0, 43, 91)",
      fontSize: 18,
      fontWeight: "bold",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "rgba(165, 215, 232, .07)",
    },
    display: "grid",
    gridTemplateRows: "auto 1f auto",
  };

  return (
    <DataGrid
      columns={columns}
      rowHeight={rowHeight}
      density="compact"
      //rows={rows}
      // Below rows definition pre-computes row number in rows
      // Read more: https://stackoverflow.com/a/79574960/9336757
      rows={rows.map((item, idx) => ({ rowNo: idx + 1, ...item }))} //
      autosizeOptions={autosizeOptions}
      getRowId={(row) => row.id}
      autoPageSize
      sx={datagridSx}
      columnVisibilityModel={columnVisibilityModel}
      pagination
      {...rows}
      getRowSpacing={(params) => ({
        top: params.isFirstVisible ? 0 : 0,
        bottom: params.isLastVisible ? 0 : 0,
      })}
    />
  );
}
